import React from 'react';

import { ViewAccessWrapper } from '../../components';
import { TESTING } from '../../constants/views';
import { useGlobalState } from '../../hooks/global';

const streamlitContainerStyles = {
  width: '(100% + 20px)',
  height: '95vh',
  margin: '-10px',
  marginBottom: '-200px',
  display: 'flex',
  lexDirection: 'column',
};

const getStreamlitUrl = () => {
  if (window.location.hostname.includes('staging')) {
    return 'https://streamlit-experiments-application-staging-nyc1.rockerboxmedia.com';
  }
  return 'https://streamlit-experiments-application-production-nyc1.rockerboxmedia.com';
};

const Testing = () => {
  const { jwt } = useGlobalState();
  const iframeSrc = jwt ? `${getStreamlitUrl()}?jwks=${jwt}` : undefined;

  return (
    <div style={streamlitContainerStyles}>
      <iframe
        title="Unified Attribution"
        src={iframeSrc}
        style={{ width: '100%', height: '100%', border: 'none', flex: '1 1 auto' }}
      />
    </div>
  );
};
const TestingAccess = () => (
  <ViewAccessWrapper
    viewName={TESTING}
    viewComponent={<Testing />}
    allowPreview
  />
);

export default TestingAccess;
